"use strict";

import angular from "angular";

angular.module("nucont.accounting.journey", ["nucont.shared"]);
require("./journey.routes");
